
import user from "@/mixins/user"

export default {
  mixins: [user],

  data() {
    return {
      isMobileCategoriesOpen: false
    }
  },

  methods: {
    handleShowMobileCategories() {
      this.isMobileCategoriesOpen = true
    },
    handleHideMobileCategories() {
      this.isMobileCategoriesOpen = false
    }
  }
}
